export enum FiltroCliente {
  Todos = 0,
  Nome = 1,
  CNPJ_CPF = 2  
}